import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f863582"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card Filter-card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "План", -1))
const _hoisted_4 = {
  key: 0,
  class: "card",
  style: {"margin":"15px 0"}
}
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Номер заказа", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Строка заказа", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Номенклатура заказа", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Сечение пакета", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Длина пакета", -1))
const _hoisted_11 = {
  key: 0,
  class: "dx-button-text"
}
const _hoisted_12 = {
  key: 1,
  class: "dx-button-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxButton = _resolveComponent("DxButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _hoisted_3,
          _createVNode(_component_CatalogueSelectControl, {
            filters: [{ column: 'stateDescription', value: 'Решение найдено' }],
            class: "ModelField-selectControl",
            stylingMode: "outlined",
            id: _ctx.model.planId,
            "onUpdate:id": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.planId) = $event)),
            desc: _ctx.model.planDescription,
            "onUpdate:desc": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.planDescription) = $event)),
            keyField: "id",
            displayDescField: "name",
            catalogueComponentName: "journals/PlanJournal/PlanJournal",
            hasEmptyValue: true,
            onChanged: _ctx.onPlanChange
          }, null, 8, ["id", "desc", "onChanged"])
        ]),
        (_ctx.showOptions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _hoisted_6,
                  _createVNode(_component_DxSelectBox, {
                    class: "ModelField-control",
                    items: _ctx.options.order,
                    "display-expr": "number",
                    "value-expr": "id",
                    value: _ctx.selectedOptions.orderId,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedOptions.orderId) = $event)),
                    "search-enabled": true,
                    stylingMode: "outlined",
                    "show-clear-button": true,
                    onValueChanged: _ctx.onFilterChange
                  }, null, 8, ["items", "value", "onValueChanged"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_7,
                  _createVNode(_component_DxSelectBox, {
                    class: "ModelField-control",
                    items: _ctx.options.nomenclatureLine,
                    "display-expr": "line",
                    "value-expr": "id",
                    value: _ctx.selectedOptions.nomenclatureId,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedOptions.nomenclatureId) = $event)),
                    "search-enabled": true,
                    stylingMode: "outlined",
                    "show-clear-button": true,
                    onValueChanged: _ctx.onFilterChange
                  }, null, 8, ["items", "value", "onValueChanged"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_8,
                  _createVNode(_component_DxSelectBox, {
                    class: "ModelField-control",
                    items: _ctx.options.nomenclature,
                    value: _ctx.selectedOptions.nomenclatureName,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedOptions.nomenclatureName) = $event)),
                    "search-enabled": true,
                    stylingMode: "outlined",
                    "show-clear-button": true,
                    onValueChanged: _ctx.onFilterChange
                  }, null, 8, ["items", "value", "onValueChanged"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_9,
                  _createVNode(_component_DxSelectBox, {
                    class: "ModelField-control",
                    items: _ctx.options.packageCut,
                    value: _ctx.selectedOptions.packageCut,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedOptions.packageCut) = $event)),
                    "search-enabled": true,
                    stylingMode: "outlined",
                    "show-clear-button": true,
                    onValueChanged: _ctx.onFilterChange
                  }, null, 8, ["items", "value", "onValueChanged"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_10,
                  _createVNode(_component_DxSelectBox, {
                    class: "ModelField-control",
                    items: _ctx.options.packageLength,
                    value: _ctx.selectedOptions.packageLength,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedOptions.packageLength) = $event)),
                    "search-enabled": true,
                    stylingMode: "outlined",
                    "show-clear-button": true,
                    onValueChanged: _ctx.onFilterChange
                  }, null, 8, ["items", "value", "onValueChanged"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_DxButton, {
          disabled: !_ctx.model.planId,
          class: "Plan-reportButton",
          type: "default",
          onClick: _ctx.onButtonClick,
          "styling-mode": "outlined"
        }, {
          content: _withCtx(() => [
            _createElementVNode("span", null, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Сформировать"))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, "Остановить"))
            ])
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ])
  ]))
}